if (!customElements.get('adev-related-articles')) {
    customElements.define('adev-related-articles', class adevRelatedArticles extends HTMLElement {
        constructor() {
            super();
        }

        initSlider(){
            const carouselEl = this.querySelector('[data-adev-related-articles="carousel"]');

            const getCellAlign = () => window.innerWidth < 768 ? 'center' : 'left';

            this.slider = new Flickity(carouselEl, {
                cellAlign: getCellAlign(),
                contain: true,
                wrapAround: true,
                prevNextButtons: false,
                pageDots: true
            });

            this._onResize = () => {
                const align = getCellAlign();
                this.slider.options.cellAlign = align;
                this.slider.resize();
                this.slider.positionCells();
                this.slider.select(this.slider.selectedIndex, false, true);
            };

            window.addEventListener('resize', this._onResize);
        }

        destroySlider(){
            if (this.slider) {
                this.slider.destroy();
            }
            
            if (this._onResize) {
                window.removeEventListener('resize', this._onResize);
                this._onResize = null;
            }
        }

        connectedCallback() {
            this.initSlider();
        }

        disconnectedCallback() {
            this.destroySlider();
        }

    });
}